import React from 'react';
import { useTheme } from '@/contexts/ThemeContext';

const CombinedAttribution: React.FC = () => {
    const { isDark } = useTheme();
    const whoopLogo = isDark
        ? '/logos/whoop/Logo/Circle/WHOOP Circle White.svg'
        : '/logos/whoop/Logo/Circle/WHOOP Circle Black.svg';

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                margin: 16,
                width: '100%',
                boxSizing: 'border-box',
                gap: 12,
            }}
        >
            {/* WHOOP Attribution */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={whoopLogo}
                    alt="WHOOP Puck Logo"
                    style={{ width: 24, height: 24, marginRight: 4, opacity: 0.85, padding: 0 }}
                />
                <span
                    className="cgm-text-primary"
                    style={{
                        fontSize: 10,
                        fontWeight: 600,
                        letterSpacing: '0.05em',
                        opacity: 0.85,
                        textShadow: isDark ? '0 1px 2px #000' : '0 1px 2px #fff',
                        padding: 0,
                    }}
                >
                    WHOOP
                </span>
            </div>
            
            {/* X Separator */}
            <span
                className="cgm-text-secondary"
                style={{
                    fontSize: 12,
                    fontWeight: 600,
                    opacity: 0.6,
                }}
            >
                ×
            </span>
            
            {/* Garmin Attribution */}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src="/logos/garmin/garmin-branding/Garmin_Connect_app_1024x1024-02.png"
                    alt="Garmin Connect Logo"
                    style={{ 
                        width: 24, 
                        height: 24, 
                        marginRight: 4, 
                        opacity: 0.85, 
                        padding: 0,
                        borderRadius: 5,
                    }}
                />
                <span
                    className="cgm-text-primary"
                    style={{
                        fontSize: 10,
                        fontWeight: 600,
                        letterSpacing: '0.05em',
                        opacity: 0.85,
                        textShadow: isDark ? '0 1px 2px #000' : '0 1px 2px #fff',
                        padding: 0,
                    }}
                >
                    Garmin
                </span>
            </div>
        </div>
    );
};

export default CombinedAttribution;
